<template>
  <v-container>
    <img src="../../assets/breadcrumb1.svg" />

    <h1 class="title mt-2">What is the name of your business?</h1>
    <h2 class="subheading">
      Your state may require the legal name of the company to be unique from other businesses who
      are registered with the state. The business name you provide will be researched by Legal House
      to ensure that it is available for registration.
    </h2>
    <v-form ref="form">
      <v-text-field
        v-model="businessName"
        :rules="[required]"
        browser-autocomplete="organization"
        label="Preferred Business Name"
        data-cy="business"
      />
      <v-select
        v-model="designation"
        :rules="[required]"
        :items="suffixes[type === 'llc' ? 'llc' : 'other']"
        label="Select Your Designator"
      />
      <v-text-field
        v-model="alternate"
        :rules="[required]"
        label="Alternate Business Name"
        data-cy="alternate"
      />
      <v-select
        v-model="category"
        :rules="[required]"
        :items="categories"
        label="Choose Your Business Category"
      />
      <v-textarea
        v-model="description"
        :rules="[required]"
        outline
        name="description"
        label="Please briefly describe your business activity"
        data-cy="description"
      />
      <v-layout justify-space-around>
        <v-btn @click="$router.go(-1);">Back</v-btn>
        <v-btn color="info" @click="done">Continue</v-btn>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
import { omit } from 'lodash-es';
import firebase from 'firebase/app';
import 'firebase/database';
import { mapState } from 'vuex';

const db = firebase.database;

export default {
  data: () => ({
    suffixes: {
      llc: [
        'LLC',
        'L.L.C.',
        'LC',
        'L.C.',
        'Ltd. Co.',
        'Ltd. Company',
        'Ltd. Liability Co.',
        'Ltd. Liability Company',
        'Limited Co.',
        'Limited Company',
        'Limited Liability Co.',
        'Limited Liability Company',
        'PLLC',
        'P.L.L.C.',
        'Professional LLC',
        'Professional L.L.C.',
        'Professional Limited Liability Company',
      ],
      other: [
        'Inc',
        'Inc.',
        'Co.',
        'Corp.',
        'Ltd.',
        'Incorporated',
        'Company',
        'Corporation',
        'Limited',
        'P.C.',
        'Professional Corporation',
      ],
    },
    category: '',
    categories: [
      'Accommodations',
      'Construction',
      'Consulting',
      'Entertainment',
      'Finance',
      'Food Service',
      'Health Care',
      'Insurance',
      'Manufacturing',
      'Professional',
      'Real Estate',
      'Rental &amp; Leasing',
      'Retail',
      'Social Assistance',
      'Technology',
      'Transportation',
      'Warehousing',
      'Wholesale',
      'Other',
    ],
    businessName: '',
    designation: '',
    alternate: '',
    description: '',
  }),
  computed: mapState(['token', 'type']),
  methods: {
    async done() {
      if (!this.$refs.form.validate()) return;
      await db()
        .ref(`info/${this.token}/business`)
        .update(omit(this.$data, ['suffixes', 'categories']));
      this.$router.push({ path: 'address' });
    },
    required: field => !!field || 'This field is required',
  },
};
</script>
